import { render, staticRenderFns } from "./FormFieldHolder.vue?vue&type=template&id=07482bcc&scoped=true&"
import script from "./FormFieldHolder.vue?vue&type=script&lang=js&"
export * from "./FormFieldHolder.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldHolder.vue?vue&type=style&index=0&id=07482bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07482bcc",
  null
  
)

export default component.exports